import { DocumentTemplate } from './types';

/**
 * Resolve the full template behind an assignment. The purposes endpoint only
 * returns {id, name, ...} without contentHtml, and the loaded list can miss it
 * (pagination/type filter differ from the purposes endpoint), so fall back to a
 * direct fetch instead of silently doing nothing.
 */
export async function resolveAssignedTemplate(
    id: number,
    templates: DocumentTemplate[],
    fetchById: (id: number) => Promise<DocumentTemplate>,
): Promise<DocumentTemplate> {
    const cached = templates.find(t => t.id === id);
    return cached ?? fetchById(id);
}
